import { render, staticRenderFns } from "./MobileNotice.vue?vue&type=template&id=0780d3c8&scoped=true&"
import script from "./MobileNotice.vue?vue&type=script&lang=js&"
export * from "./MobileNotice.vue?vue&type=script&lang=js&"
import style0 from "./MobileNotice.vue?vue&type=style&index=0&id=0780d3c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0780d3c8",
  null
  
)

export default component.exports